import { useTranslation } from 'react-i18next';
import type { OrderRowData } from '@/hooks/useHomeData';

interface RecentOrdersProps {
  items: OrderRowData[];
}

export function RecentOrders({ items }: RecentOrdersProps) {
  const { t } = useTranslation();
  return (
    <section className="home-card">
      <header className="home-card-header">
        <h3>{t('home.recent_orders')}</h3>
        <a href="#" className="home-card-link">
          {t('home.view_all')}
        </a>
      </header>
      {items.map((row) => (
        <div key={row.id} className="order-row" role="button">
          <div className="order-avatar">{row.customerInitials}</div>
          <div className="order-info">
            <div className="order-id">{row.id}</div>
            <div className="order-client">{row.client}</div>
            <div className="order-progress">
              <div className="progress-bar">
                <div
                  className="progress-fill"
                  data-fill={row.fill}
                  style={{ width: `${row.progress}%` }}
                />
              </div>
              <span className="progress-pct">{row.progress}%</span>
            </div>
          </div>
          <div className="order-meta">
            <div className="status-badge" data-status={row.status}>
              {t(`home.status_${row.status}`)}
            </div>
            <div className="order-date">{row.date}</div>
          </div>
        </div>
      ))}
    </section>
  );
}
